import * as JSZip from 'jszip';

export function downloadAllResource(info: any[]): Promise<Blob | null> {
    const resources = info?.filter((item: any) => item?.files?.[0]?.url) || [];
    if (resources.length === 0) return Promise.resolve(null);

    const zip = new JSZip();
    const filePromises: Promise<void>[] = [];

    resources.forEach((resource) => {
        resource?.files?.forEach((file: any) => {
            const fileUrl = file?.url;
            const typeOfResource = resource?.typeOfResource;
            const referential = resource?.referentProduct
                ? resource?.referentProduct
                : resource?.linkToProductInfo?.[0]?.referenceProduct;
            const filename = resource?.title
                ? getSafeFilename(resource?.title || 'file', fileUrl, typeOfResource, referential)
                : resource?.title;

            const filePromise = fetch(fileUrl)
                .then((response) => {
                    if (!response.ok) throw new Error(`Failed to download: ${fileUrl}`);
                    return response.blob();
                })
                .then((blob) => {
                    zip.file(filename, blob);
                })
                .catch((error) => console.error('Error downloading file:', error));

            filePromises.push(filePromise);
        });
    });

    return Promise.all(filePromises)
        .then(() => zip.generateAsync({ type: 'blob' }))
        .catch((error) => {
            console.error('Error generating ZIP:', error);
            return null;
        });
}

let usedFilenames = new Set<string>();

export function resetUsedFilenames(): void {
    usedFilenames.clear();
}

export function getSafeFilename(
    title: string,
    fileUrl: string,
    typeOfResource: string,
    referential: string
): string {
    const fileExtension = getFileExtensionFromUrl(fileUrl);

    let filename = decodeURIComponent(title).toUpperCase().replace(/ /g, '-');
    filename = filename.replace(/["'&=$€*\/+\[\]{}|]/g, '-');

    let baseFilename = `${referential}-${typeOfResource}.${fileExtension}`;
    let finalFilename = baseFilename;
    let counter = 1;

    while (usedFilenames.has(finalFilename)) {
        const nameWithoutExt = baseFilename.substring(0, baseFilename.lastIndexOf('.'));
        const ext = baseFilename.substring(baseFilename.lastIndexOf('.'));
        finalFilename = `${nameWithoutExt}(${counter})${ext}`;
        counter++;
    }

    usedFilenames.add(finalFilename);

    return finalFilename;
}

export function getFileExtensionFromUrl(url: string) {
    try {
        const pathname = new URL(url).pathname; // Lấy phần đường dẫn từ URL
        const filename = pathname.split('/').pop(); // Lấy tên file
        const extension = filename?.split('.').pop(); // Lấy phần mở rộng

        return extension?.includes('?') ? extension.split('?')[0] : extension; // Xử lý nếu có query string
    } catch (error) {
        console.error('Invalid URL:', error);
        return '';
    }
}
